module.exports = __webpack_public_path__ + "static/gallery25-7dcade8ae52ce2d4f82d5d0f8f824bf5.png";